/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_IndexInputs */



/**
* | output |
* | --- |
* | "Match by Index" |
*
* @param {Metadata_Merge_Match_By_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_index = /** @type {((inputs?: Metadata_Merge_Match_By_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Correspondance par index")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übereinstimmung nach Index")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corrispondenza per indice")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Совпадение по индексу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Coincidencia por índice")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按索引匹配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インデックスによる一致")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूचकांक के अनुसार मिलान करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correspondência por índice")
	return /** @type {LocalizedString} */ ("Match by Index")
});